export default "__VITE_ASSET__CpH0a4Yt__"